module.exports = __webpack_public_path__ + "static/3-425a1f95c7d36dba27a66e6d474090b4.jpg";